export default "__VITE_ASSET__gRLKRFZl__"